/* eslint-disable react/prop-types */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { ReactComponent as GlobeLogo } from '@bostonglobe/logos/logos/bglobe/bglobe-logo-black.svg';
import { ReactComponent as GlobeBug } from '@bostonglobe/logos/logos/bglobe/bglobe-bug-black.svg';
import { ReactComponent as Mail } from '~assets/images/mail.svg';
import { ReactComponent as Facebook } from '~assets/images/facebook.svg';
import { ReactComponent as Twitter } from '~assets/images/twitter.svg';
import generateMailtoLink from '~lib/generateMailtoLink';
import generateFacebookLink from '~lib/generateFacebookLink';
import generateTwitterLink from '~lib/generateTwitterLink';

import '~styles/modules/header.scss';
import '~styles/modules/logo.scss';

const Header = ({ hclass }) => {
  const data = useStaticQuery(graphql`
      query SiteHeaderQuery {
          site {
              siteMetadata {
                  title
                  siteName
              }
          }
      }
  `);
  const [pageUrl, setPageUrl] = React.useState('');
  React.useEffect(
    () => {
      setPageUrl(window.location.href);
    },
    [],
  );
  const socialSettings = {
    url: pageUrl,
    text: data.site.siteMetadata.title,
  };
  const headerClassName = `header ${hclass}`;

  return (
    <header className={headerClassName}>
      <div className="header__inner">
        <div className="header__logo">
          <a href="http://www.bostonglobe.com">
            <GlobeLogo
              className="logo--lg"
              viewBox="0 0 500 67"
              width={140}
              height={18}
            />
            <GlobeBug
              className="logo--sm"
              viewBox="0 0 500 500"
              width={15}
              height={18}
            />
          </a>
        </div>
        <div className="header__share">
          <a
            href={generateMailtoLink(socialSettings)}
            target="_blank"
            rel="noreferrer"
            className="header__share-button"
          >
            <Mail />
          </a>
          <a
            href={generateFacebookLink(socialSettings)}
            target="_blank"
            rel="noreferrer"
            className="header__share-button"
          >
            <Facebook />
          </a>
          <a
            href={generateTwitterLink(socialSettings)}
            target="_blank"
            rel="noreferrer"
            className="header__share-button"
          >
            <Twitter />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
